module.exports = __webpack_public_path__ + "static/img/newsDetailPic8.fe6216e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic8.png
// module id = pGGf
// module chunks = 1